<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';

  import { Icon } from '@shared/ui/icon';
  import { getPrice } from '@shared/utils/blockchain';

  const wallet = useWallet();
</script>

<article class="text-default-900 mt-5 rounded-lg bg-yellow-100 p-3 dark:bg-yellow-200">
  <p class="mb-1 text-sm font-medium">
    Your Wallet Balance: {getPrice($wallet?.balance.usdc)} USDC / {getPrice($wallet?.balance.eth)} ETH
  </p>

  <p class="text-default-800 mb-2 text-xs">
    Insufficient funds. We couldn’t detect any funds in your connected wallet.
  </p>

  <div class="flex gap-2 text-xs">
    <Icon name="ethereum" width="{18}" height="{24}" classes="shrink-0" />

    <p>
      If you're not seeing your funds, it's possible that your wallet is connected to the
      <strong class="font-semibold"> wrong network. </strong>
      Please ensure you're connected to the
      <strong class="font-semibold">Ethereum Mainnet,</strong>
      and that your tokens are stored on this network.
    </p>
  </div>
</article>
